import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/required-uuid-string.js';
export const leafLinkHeldOrderIdArgsSchema = z.object({
    heldOrderId: requiredUuidString('Held order is required.', 'Invalid held order.'),
});
//# sourceMappingURL=leaflink-held-order-id-args-schema.js.map